import { useTranslation } from "@/i18n/useTranslation";

const TrustTicker = () => {
  const { locale } = useTranslation();
  const items = locale === "fr"
    ? ["Commerce de détail", "Biens de consommation", "Services professionnels", "Franchises", "Marques DTC"]
    : ["Retail & Ecommerce", "CPG", "Professional Services", "Franchise", "DTC Brands"];

  return (
    <div className="overflow-hidden py-5 relative">
      <div className="shimmer-line absolute top-0 left-0 right-0" />
      <div className="shimmer-line absolute bottom-0 left-0 right-0" />
      <div className="absolute right-0 top-0 bottom-0 w-28 z-10 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      <div className="absolute left-0 top-0 bottom-0 w-28 z-10 bg-gradient-to-r from-background to-transparent pointer-events-none" />
      <div className="animate-ticker whitespace-nowrap flex">
        {[...items, ...items, ...items, ...items].map((item, i) => (
          <span key={i} className="inline-flex items-center mx-14">
            <span className="font-mono text-[10px] font-medium tracking-[0.22em] uppercase text-muted-foreground/20">
              {item}
            </span>
            <span className="ml-28 w-[2px] h-[2px] rounded-full bg-primary/10" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default TrustTicker;
